﻿import { CHANGE_STATE } from '~/Scripts/Handlers/StateHandler';
import { MENU_OPEN } from '../../Menu/Scripts/index';
import Emitter from 'events';

export default class SiteHeader extends Emitter {
  constructor() {
    super();
    this.setupComponent();
  }

  setupComponent() {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const menuClose = document.querySelector('[data-menu-close]');

    if (menuToggle) {
      menuToggle.addEventListener('click', this.clickedOpen);
    }

    if (menuClose) {
      menuClose.addEventListener('click', this.clickedClose);
    }
  }

  clickedOpen = (event) => {
    event.preventDefault();
    this.emit(CHANGE_STATE, { [MENU_OPEN]: true });
  }

  clickedClose = (event) => {
    event.preventDefault();
    this.emit(CHANGE_STATE, { [MENU_OPEN]: false });
  }
}